import { useLocale } from '../../../context/NbLocalizationContext';
import { ModalFooter } from '../../../shared/components/modal/ModalFooter';
import { ModalHeader } from '../../../shared/components/modal/ModalHeader';
import classes from './MifidMessageModal.module.scss';

export interface MifidMessageModalProps {
  onCancel: () => void;
  text: string;
}

export const MifidMessageModal = ({ onCancel, text }: MifidMessageModalProps) => {
  const { translation } = useLocale();

  return (
    <div className={classes.modal}>
      <ModalHeader
        title={translation.mifidModal.title}
        onClose={onCancel}
        className={classes.modalHeader}
        isSmall
        isWithDivider
        hideCloseButton
      />

      <div className={classes.modalContent}>
        <p className={classes.modalText}>{text}</p>
      </div>

      <ModalFooter right={{ title: translation.mifidModal.ok, action: onCancel }} />
    </div>
  );
};
